import api from './api';
import authHeader from './auth-header';

class EmployeeService {
    getEmployees() {
        return api.get('/employees', { headers: authHeader() });
    }

    getInsights(period) {
        return api.get(`/employees/insights?period=${period}`, { headers: authHeader() });
    }

    // Kompletný detail pre stránku /employees/:id — jedna požiadavka.
    // Obdobie je kalendárne: { month: '2026-07' } alebo { year: '2026' }.
    getProfile(employeeId, range = {}) {
        const query = range.year ? `year=${range.year}` : `month=${range.month}`;
        return api.get(`/employees/${employeeId}/profile?${query}`, { headers: authHeader() });
    }

    getEmployeeInsights(id, period) {
        return api.get(`/employees/${id}/insights?period=${period}`, { headers: authHeader() });
    }

    getEmployee(id) {
        return api.get(`/employees/${id}`, { headers: authHeader() });
    }

    createEmployee(employeeData) {
        return api.post('/employees', employeeData, { headers: authHeader() });
    }

    parseImport(text) {
        return api.post('/employees/parse-import', { text }, { headers: authHeader() });
    }

    parseImportFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        // Default 'Content-Type: application/json' z api inštancie treba zhodiť,
        // inak prebije multipart boundary a backend súbor nevidí
        return api.post('/employees/parse-import', formData, {
            headers: { ...authHeader(), 'Content-Type': undefined },
        });
    }

    updateEmployee(id, employeeData) {
        return api.put(`/employees/${id}`, employeeData, { headers: authHeader() });
    }

    deleteEmployee(id) {
        return api.delete(`/employees/${id}`, { headers: authHeader() });
    }

    getAssignedWorkplaces(employeeId) {
        return api.get(`/employees/${employeeId}/assigned-workplaces`, { headers: authHeader() });
    }

    getAssignedWorkplacesBulk(employeeIds) {
        const params = employeeIds && employeeIds.length ? { params: { employeeIds: employeeIds.join(',') }, headers: authHeader() } : { headers: authHeader() };
        return api.get('/employees/assigned-workplaces', params);
    }

    assignWorkplaces(employeeId, workplaceIds) {
        return api.put(`/employees/${employeeId}/assign-workplaces`, { workplaceIds }, { headers: authHeader() });
    }

    sendNotification(employeeId, title, body) {
        return api.post(`/employees/${employeeId}/send-notification`, { title, body }, { headers: authHeader() });
    }
}

const employeeService = new EmployeeService();
export default employeeService; 